import { IPagedCollection, WccDto } from '@sr/dto';
import { INVOICES_BASE_URL, WCC_BASE_URL } from 'shared/api/api';
import { CollectionParams } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';
import { wccApi } from '../api';


const injectedApi = wccApi.injectEndpoints({
  endpoints: (builder) => ({
    getWccList: builder.query<IPagedCollection<WccDto>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `${WCC_BASE_URL}?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }),
    deleteWcc: builder.mutation<void, number>({
      query: (id: number) => ({
        url: `${WCC_BASE_URL}/${id}`,
        method: 'DELETE'
      }),
    }),
    deleteWccByInvoceId: builder.mutation<void, number>({
      query: (id: number) => ({
        url: `${INVOICES_BASE_URL}/wcc/${id}`,
        method: 'DELETE'
      }),
    }),
  }),
  overrideExisting: true
});

export const wccListApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['client-wcc-list', 'supplier-wcc-list'],
  endpoints: {
    getWccList: {
      providesTags: (_, err, arg) => {
        if (err) return [];
        const type = new URLSearchParams(arg.filter).get('type');
        if (type === 'client') return ['client-wcc-list'];
        if (type === 'supplier') return ['supplier-wcc-list']
        return ['client-wcc-list', 'supplier-wcc-list'];
      }
    },
    deleteWcc: {
      invalidatesTags: (_, err, __) => {
        if (err) return [];
        return ['client-wcc-list', 'supplier-wcc-list'];
      }
    },
    deleteWccByInvoceId: {
      invalidatesTags: (_, err, __) => {
        if (err) return [];
        return ['client-wcc-list', 'supplier-wcc-list'];
      }
    }
  }
})